import styles from "./style.module.scss";
import Living from "src/assets/living.jpg";

export const LivingSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>
          Room<span>-ルーム-</span>
        </h2>
        <h3>
          Living<span>-リビング-</span>
          <div className={styles.border} />
        </h3>
        <div className={styles.imageBox}>
          <img src={Living} alt="living" />
        </div>
        <div className={styles.grayBox} />
        <div className={styles.whiteBox}>
          <p>
            玄関を開けると、壁やパーテーションのない広々としたリビングがすぐに見えます。全体を使ってゆったりくつろいだり、食卓でご飯を食べたり。天井が高く、サーフボードを楽々立てかけることもできます。
          </p>
        </div>
      </div>
    </section>
  );
};
